import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useAddGroup = (setId, setEdit, setShowCreateGroup) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.ADD_GROUP],
    (data) => ApiService.addGroup(data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(QUERY_KEY.GET_GROUP);
        setId(data.data.id);
        setEdit(false);
        setShowCreateGroup(false);
        toast.success("Group added successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useAddGroup;
